import React from 'react';
import HigashikawaHero from '../components/higashikawa/HigashikawaHero';
import HigashikawaInfo from '../components/higashikawa/HigashikawaInfo';
import HigashikawaSchedule from '../components/higashikawa/HigashikawaSchedule';

const HigashikawaPage = () => {
  return (
    <div className="bg-[#FAF9F6]"> {/* Slightly warmer off-white for Japanese vibe */}
      <HigashikawaHero />
      <HigashikawaInfo />
      <HigashikawaSchedule />
    </div>
  );
};

export default HigashikawaPage;